import script from "./TokenIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./TokenIcon.vue?vue&type=script&setup=true&lang=ts"

import "./TokenIcon.vue?vue&type=style&index=0&id=6ce1fc96&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/curl-fe-build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ce1fc96"]])

export default __exports__